import React, { createContext, useState, useEffect, useCallback } from 'react'

import Map from 'ol/Map'
import View from 'ol/View'
import TileLayer from 'ol/layer/Tile'
import OSM from 'ol/source/OSM'
import 'ol/ol.css'
import { defaults as defaultControls, ScaleLine } from 'ol/control';

const MapContext = createContext([{}, () => { }])

const MapProvider = (props) => {
	const createMap = useCallback(() => {
		return new Map({
			controls: defaultControls().extend([
				new ScaleLine({
					units: 'metric'
					// units: 'metric',
					// bar: true,
					// steps: 2,
					// text: false,
					// minWidth: 140
				})
			]),
			view: new View({
				projection: props.projection,
				center: props.center,
				zoom: props.zoom
			}),
			layers: [
				new TileLayer({
					source: new OSM(),
					zIndex: 1
				})
			],
			target: 'mapId'
		})
	}, [props])

	const [map, setMap] = useState()

	useEffect(() => {
		!map && setMap(createMap())
	}, [map, createMap])

	return (
		<MapContext.Provider value={map}>
			<div id="mapId" onMouseLeave={props.onMouseLeave}>
				{props.children}
			</div>
		</MapContext.Provider>
	)
}


export { MapContext, MapProvider }